import placeTypes from "../open-planet/placeTypes";

/**
 * Returns a segment containing place information to be used in the meta title
 * @param  {Object} place       Place data object
 * @return {String}
 */
export default function createPlaceMetaTitle(place = {}) {
  const placeTitle = [];

  const shouldAddCity = place.placeType === placeTypes.neighborhood;
  const shouldAddCountry = place.placeType === placeTypes.city || place.placeType === placeTypes.neighborhood;
  const isCorrectPlaceType = place.placeType === placeTypes.city ||
    place.placeType === placeTypes.region ||
    place.placeType === placeTypes.neighborhood ||
    place.placeType === placeTypes.country;

  if (isCorrectPlaceType && place.name) {
    placeTitle.push(place.name);
  }

  if (place.ancestry) {
    for (let i = 0, b = place.ancestry.length; i < b; i += 1) {
      if (shouldAddCity && place.ancestry[i].placeType === "city") {
        placeTitle.push(place.ancestry[i].name);
      }

      if (shouldAddCountry && place.ancestry[i].placeType === "country") {
        placeTitle.push(place.ancestry[i].name);
      }
    }
  }

  return placeTitle.length ? ` in ${placeTitle.join(", ")}` : "";
}



// WEBPACK FOOTER //
// ../server/lib/helpers/metaDataPlaceTitle.js